import "@hotwired/turbo"
import "./controllers"
import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Chargement manuel d’un controller par exemple
import HelloController from "./controllers/hello_controller.js"
application.register("hello", HelloController)


console.log("✅ JavaScript loaded");

// --- Mode sombre forcé ---
document.documentElement.classList.add('dark');

// Fonction pour initialiser tous les event listeners
function initializeEventListeners() {
  console.log("🔥 Initialisation des event listeners !");

  // --- Menu mobile ---
  const toggle = document.getElementById("mobile-menu-toggle");
  const menu = document.getElementById("mobile-menu");

  if (toggle && menu) {
    if (toggle._listener) toggle.removeEventListener("click", toggle._listener);

    toggle._listener = () => {
      menu.classList.toggle("hidden");
    };

    toggle.addEventListener("click", toggle._listener);
  }

  // // --- Scroll navbar ---
  // const navbar = document.getElementById("navbar");
  // if (navbar) {
  //   const handleScroll = () => {
  //     if (window.scrollY > 100) {
  //       navbar.classList.add("bg-gray-700", "shadow-md");
  //       navbar.classList.remove("bg-siteBg");
  //     } else {
  //       navbar.classList.remove("bg-gray-700", "shadow-md");
  //       navbar.classList.add("bg-siteBg");
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   handleScroll(); // initial call
  //   console.log("📦 Scroll handler initialisé");
  // } else {
  //   console.warn("🔶 Aucun élément avec id='navbar' trouvé.");
  // }

  // // --- Scroll navbar mobile ---
  // const navbarMobile = document.querySelector(".lg\\:hidden.sticky");
  // if (navbarMobile) {
  //   const handleScrollMobile = () => {
  //     if (window.scrollY > 100) {
  //       navbarMobile.classList.add("bg-gray-900", "shadow-md");
  //       navbarMobile.classList.remove("bg-gray-800");
  //     } else {
  //       navbarMobile.classList.remove("bg-gray-900", "shadow-md");
  //       navbarMobile.classList.add("bg-gray-800");
  //     }
  //   };

  //   window.addEventListener("scroll", handleScrollMobile);
  //   handleScrollMobile(); // initial call
  //   console.log("📦 Scroll handler mobile initialisé");
  // }


  // --- Scroll navbar desktop + mobile ---
  const navbarDesktop = document.getElementById("navbar");
  const navbarMobile = document.querySelector(".lg\\:hidden.sticky");

  const handleScrollNavbars = () => {
    if (window.scrollY > 100) {
      if (navbarDesktop) {
        navbarDesktop.classList.add("bg-gray-700", "shadow-md");
        navbarDesktop.classList.remove("bg-siteBg");
      }
      if (navbarMobile) {
        navbarMobile.classList.add("bg-gray-900", "shadow-md");
        navbarMobile.classList.remove("bg-gray-800");
      }
    } else {
      if (navbarDesktop) {
        navbarDesktop.classList.remove("bg-gray-700", "shadow-md");
        navbarDesktop.classList.add("bg-siteBg");
      }
      if (navbarMobile) {
        navbarMobile.classList.remove("bg-gray-900", "shadow-md");
        navbarMobile.classList.add("bg-gray-800");
      }
    }
  };

  window.addEventListener("scroll", handleScrollNavbars);
  handleScrollNavbars(); // initial call
  console.log("📦 Scroll handler desktop + mobile initialisé");

  // --- Gestion des ancres avec offset (pour que le contenu ne se cache pas sous la navbar sticky) ---
  function handleAnchorScroll(e) {
    const href = e.currentTarget.getAttribute('href');
    
    // Vérifier si c'est une ancre interne
    if (href && href.startsWith('#') && href.length > 1) {
      e.preventDefault();
      
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // Offset de 160px pour laisser de l'espace sous la navbar sticky
        const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 160;
        
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }
  }
  
  // Attacher le handler à tous les liens d'ancre dans la navbar
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', handleAnchorScroll);
  });
  console.log("📍 Anchor scroll offset initialisé");


  // --- Filtrage par catégorie + Voir plus / Voir moins + flèche + scroll ---
  const dropdown = document.getElementById("category-select");
  const articles = document.querySelectorAll("article[data-category]");
  const seeMoreBtn = document.getElementById("seeMoreBtn");
  const seeMoreContainer = document.getElementById("see-more-container");

  const seeMoreBtnText = seeMoreBtn?.querySelector("#seeMoreBtnText");
  const seeMoreBtnArrow = seeMoreBtn?.querySelector("#seeMoreBtnArrow");

  let expanded = false;
  const defaultVisibleCount = 3;

  function getFilteredArticles() {
    const selected = dropdown?.value || "all";
    
    return Array.from(articles).filter(article => {
      if (selected === "all") return true;
      const categories = article.getAttribute("data-category").split(" ").filter(c => c);
      return categories.includes(selected);
    });
  }

  function updateVisibility(filteredArticles) {
    // On ne touche qu’aux articles concernés
    articles.forEach(article => {
      article.classList.add("hidden");
      article.classList.remove("extra-article");
    });

    filteredArticles.forEach((article, i) => {
      if (expanded || i < defaultVisibleCount) {
        article.classList.remove("hidden");
      } else {
        article.classList.add("extra-article");
      }
    });
  }

  function updateSeeMoreButton(filteredArticles) {
    if (!seeMoreBtn || !seeMoreContainer) return;

    if (filteredArticles.length > defaultVisibleCount) {
      seeMoreBtn.classList.remove("hidden");
    } else {
      seeMoreBtn.classList.add("hidden");
    }
  }

  if (dropdown) {
    dropdown.addEventListener("change", (e) => {
      expanded = false;

      const filteredArticles = getFilteredArticles();
      updateVisibility(filteredArticles);
      updateSeeMoreButton(filteredArticles);

      if (seeMoreBtnText && seeMoreBtnArrow) {
        seeMoreBtnText.innerText = "Voir plus";
        seeMoreBtnArrow.style.transform = "rotate(0deg)";
      }

      const url = new URL(window.location.href);
      const selected = e.target.value;
      if (selected === "all") {
        url.searchParams.delete("category");
      } else {
        url.searchParams.set("category", selected);
      }
      history.replaceState(null, "", url.toString());
    });
  }

  if (seeMoreBtn && seeMoreBtn.tagName.toLowerCase() === 'button') {
    seeMoreBtn.addEventListener("click", () => {
      expanded = !expanded;
      const filteredArticles = getFilteredArticles();
      updateVisibility(filteredArticles);

      if (seeMoreBtnText && seeMoreBtnArrow) {
        if (expanded) {
          seeMoreBtnText.innerText = "Voir moins";
          seeMoreBtnArrow.style.transform = "rotate(180deg)";
        } else {
          seeMoreBtnText.innerText = "Voir plus";
          seeMoreBtnArrow.style.transform = "rotate(0deg)";

          const container = document.getElementById("articles-container");
          if (container) {
            container.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }
    });
  }

  // Initialisation
  const initialFilteredArticles = getFilteredArticles();
  updateVisibility(initialFilteredArticles);
  updateSeeMoreButton(initialFilteredArticles);

  
}

// --- turbo:load (initialisation générale) ---
document.addEventListener("turbo:load", () => {
  initializeEventListeners();
});

// Aussi sur turbo:frame-load pour les frameset
document.addEventListener("turbo:frame-load", () => {
  initializeEventListeners();
});

// --- Scroll top au render (fix Firefox) ---
document.addEventListener("turbo:render", () => {
  document.body.classList.add("turbo-scroll-fix");

  const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, isFirefox ? 100 : 30);
});
